<div class="step-content" *ngIf="!isLoading; else loadingAnimation">
    <div class="row">
        <div class="col s12">
            <form [formGroup]="linesForm">
            <app-picklist
                          *ngIf="partNumber"
                          [source]="lines"
                          [disabled]="isReadOnly()"
                          [target]="partNumber?.lines"
                          [formControl]="linesForm.controls['lines']"
                          formControlName="lines"
                          [sourceHeader]="'admin.partNumbers.create-modal.pick-list.lines.leftHeader' | translate"
                          [targetHeader]="'admin.partNumbers.create-modal.pick-list.lines.rightHeader' | translate">
            </app-picklist>
            </form>
        </div>
    </div>
</div>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
